export default __webpack_public_path__ + "static/media/vip9.c070aab0.webp";